export function getCategoryFacetSearchSetInitialState() {
    return {};
}
